module.exports = __webpack_public_path__ + "img/1x.08284cb.jpg";